import React, { useState, useEffect, useCallback } from "react";
import Portfolio from "../Items/Portfolio";

const filters = [
  {
    id: 1,
    name: "All Projects",
  },
  {
    id: 2,
    name: "Data Projects",
  },
  {
    id: 3,
    name: "Web & App Projects",
  },
  {
    id: 4,
    name: "Design Projects",
  },
];

const allData = [
  {
    id: 21,
    name: "Fashion Sales Data Analysis",
    category: ["Data Projects"],
    image: "images/portfolio/dataanalyst/fashion.png",
    slug: "twentyone",
  },
  {
    id: 22,
    name: "Supermarket Sales Data Analysis",
    category: ["Data Projects"],
    image: "images/portfolio/dataanalyst/salesmarket.png",
    slug: "twentytwo",
  },
  {
    id: 23,
    name: "Supermarket Sales Data Analysis Part 2",
    category: ["Data Projects"],
    image: "images/portfolio/dataanalyst/salesmarket2.png",
    slug: "twentythree",
  },
  {
    id: 24,
    name: "Tourism Data Analysis",
    category: ["Data Projects"],
    image: "images/portfolio/dataanalyst/wisata.png",
    slug: "twentyfour",
  },
  {
    id: 26,
    name: "Text Analysis Part 2",
    category: ["Data Projects"],
    image: "images/portfolio/dataanalyst/fundingtech.png",
    slug: "twentysix",
  },
  {
    id: 25,
    name: "Performa pizza sales data analysis",
    category: ["Data Projects"],
    image: "images/portfolio/dataanalyst/pizza.png",
    slug: "twentyfive",
  },
{
    id: 27,
    name: "Nike Sales Performance Analysis (2020–2021)",
    category: ["Data Projects"],
    image: "images/portfolio/dataanalyst/nike.png",
    slug: "twentyseven",
  },

  {
    id: 28,
    name: "Superstore Sales Performance Analysis",
    category: ["Data Projects"],
    image: "images/portfolio/dataanalyst/superstore.png",
    slug: "twentyeight",
  },
  {
    id: 29,
    name: "Supermart Grocery Sales Performance Analysis",
    category: ["Data Projects"],
    image: "images/portfolio/dataanalyst/supermart.png",
    slug: "twentynine",
  },
  {
    id: 8,
    name: "Socio-Economic Analysis in Indonesia 2021",
    category: ["Data Projects"],
    image: "images/portfolio/dataanalyst/sosialekonomi.png",
    slug: "eight",
  },
  {
    id: 9,
    name: "Student Distribution by Study Program and Gender",
    category: ["Data Projects"],
    image: "images/portfolio/dataanalyst/mahasiswa.png",
    slug: "nine",
  },
  {
    id: 10,
    name: "Restaurant Sales Performance Analysis",
    category: ["Data Projects"],
    image: "images/portfolio/dataanalyst/restoran.png",
    slug: "ten",
  },
  {
    id: 11,
    name: "COVID-19 Spread Analysis in Indonesia (2020–2022)",
    category: ["Data Projects"],
    image: "images/portfolio/dataanalyst/covid192020.png",
    slug: "eleven",
  },
  {
    id: 13,
    name: "Visualization of Body Weights of Several Individuals",
    category: ["Data Projects"],
    image: "images/portfolio/dataanalyst/beratbadan.png",
    slug: "thirteen",
  },
  {
    id: 14,
    name: "Types of Data Visualization with Matplotlib",
    category: ["Data Projects"],
    image: "images/portfolio/dataanalyst/visualisasidata1.png",
    slug: "fourteen",
  },
  {
    id: 15,
    name: "Subplot Layout Configuration in Matplotlib",
    category: ["Data Projects"],
    image: "images/portfolio/dataanalyst/visualisasidata2.png",
    slug: "fifteen",
  },
  {
    id: 16,
    name: "Subplot Layout Configuration in Matplotlib",
    category: ["Data Projects"],
    image: "images/portfolio/dataanalyst/visualisasidata3.png",
    slug: "sixteen",
  },
  {
    id: 17,
    name: "Clustering Results Visualization: Elbow Method, K-Means, and DBSCAN",
    category: ["Data Projects"],
    image: "images/portfolio/dataanalyst/clustering1.png",
    slug: "seventeen",
  },
  {
    id: 18,
    name: "Visualization of Various Plot Types",
    category: ["Data Projects"],
    image: "images/portfolio/dataanalyst/visualisasidata.png",
    slug: "eighteen",
  },
  {
    id: 19,
    name: "Comparison of Classification Model Performance on the Diabetes Dataset",
    category: ["Data Projects"],
    image: "images/portfolio/dataanalyst/klasifikasi.png",
    slug: "nineteen",
  },
  {
    id: 20,
    name: "Comparison of Clustering Methods: K-Means vs DBSCAN",
    category: ["Data Projects"],
    image: "images/portfolio/dataanalyst/clustering.png",
    slug: "twenty",
  },
  {
    id: 1,
    name: "Onemens Leather Website- Admin",
    category: ["Web Projects"],
    image: "images/portfolio/Admin.png",
    slug: "one",
  },
  {
    id: 2,
    name: "Onemens Leather Website - Guest",
    category: ["Web Projects"],
    image: "images/portfolio/Pengunjung.png",
    slug: "two",
  },
  {
    id: 3,
    name: "PLant in Town! Website",
    category: ["App Projects"],
    image: "images/portfolio/PIT.png",
    slug: "three",
  },
  {
    id: 4,
    name: "Cakazen Application",
    category: ["App Projects"],
    image: "images/portfolio/Cakazen.png",
    slug: "four",
  },
  {
    id: 5,
    name: "Pusat Studi Bencana (PSB) Website",
    category: ["Web Projects"],
    image: "images/portfolio/PSB.png",
    slug: "five",
  },
  {
    id: 6,
    name: "Dapur Kopi Pasundan Website - Guest",
    category: ["Web Projects"],
    image: "images/portfolio/DKP_Pengunjung.png",
    slug: "six",
  },
  {
    id: 7,
    name: "Dapur Kopi Pasundan Website - Admin",
    category: ["Web Projects"],
    image: "images/portfolio/DKP_Admin.png",
    slug: "seven",
  },
  {
    id: 30,
    name: "Poster Infografis",
    category: ["Design Projects"],
    image: "images/portfolio/design/poster1.png",
    slug: "posterinfografis1",
  },
  {
    id: 31,
    name: "Poster Infografis",
    category: ["Design Projects"],
    image: "images/portfolio/design/poster2.png",
    slug: "posterinfografis2",
  },
  {
    id: 32,
    name: "Poster Infografis",
    category: ["Design Projects"],
    image: "images/portfolio/design/poster3.png",
    slug: "posterinfografis3",
  },
  {
    id: 33,
    name: "Poster Infografis",
    category: ["Design Projects"],
    image: "images/portfolio/design/poster4.png",
    slug: "posterinfografis4",
  },
  {
    id: 34,
    name: "Poster Infografis",
    category: ["Design Projects"],
    image: "images/portfolio/design/poster5.png",
    slug: "posterinfografis5",
  },
  {
    id: 35,
    name: "Poster Infografis",
    category: ["Design Projects"],
    image: "images/portfolio/design/poster6.png",
    slug: "posterinfografis6",
  },
];

function Portfolios({ basePath = "/works" }) {
  const [getAllItems] = useState(allData);
  const [visibleItems, setVisibleItems] = useState([]);
  const [activeFilter, setActiveFilter] = useState(filters[0].name.toLowerCase());
  const [hasMore, setHasMore] = useState(false);

  const applyFilter = useCallback(
    (filterName, expand) => {
      const normalizedFilter = filterName.toLowerCase();
      setActiveFilter(normalizedFilter);

      let filtered = [];
      if (normalizedFilter === "all projects") {
        filtered = [
          ...getAllItems.filter((item) => item.id >= 8),
          ...getAllItems.filter((item) => item.id < 8),
        ];
      } else if (normalizedFilter === "web & app projects") {
        filtered = getAllItems.filter((item) =>
          item.category
            .map((cat) => cat.toLowerCase())
            .some(
              (cat) => cat === "web projects" || cat === "app projects"
            )
        );
      } else {
        filtered = getAllItems.filter((item) =>
          item.category.map((cat) => cat.toLowerCase()).includes(normalizedFilter)
        );
      }

      const limited = expand ? filtered : filtered.slice(0, 4);
      setVisibleItems(limited);
      setHasMore(!expand && filtered.length > 4);
    },
    [getAllItems]
  );

  useEffect(() => {
    applyFilter(filters[0].name.toLowerCase(), false);
  }, [applyFilter]);

  const handleChange = (e) => {
    e.preventDefault();
    const selected = e.target.value
      ? e.target.value.toLowerCase()
      : e.target.textContent.toLowerCase();

    applyFilter(selected, false);
  };

  const handleLoadmore = (e) => {
    e.preventDefault();
    applyFilter(activeFilter, true);
  };

  return (
    <>
      <ul className="portfolio-filter list-inline">
        {filters.map((filter) => (
          <li
            className={
              filter.name.toLowerCase() === activeFilter
                ? "list-inline-item current"
                : "list-inline-item"
            }
            key={filter.id}
            onClick={handleChange}
          >
            {filter.name}
          </li>
        ))}
      </ul>

      <div className="pf-filter-wrapper mb-4">
        <select className="portfolio-filter-mobile" onChange={handleChange}>
          {filters.map((filter) => (
            <option value={filter.name} key={filter.id}>
              {filter.name}
            </option>
          ))}
        </select>
      </div>

      <div className="row portfolio-wrapper">
        {visibleItems.map((item) => (
          <div className="col-md-6 col-sm-6 grid-item" key={item.id}>
            <Portfolio portfolio={item} basePath={basePath} />
          </div>
        ))}
      </div>

      {hasMore && (
        <div className="load-more text-center mt-4">
          <a href="#!" className="btn btn-default" onClick={handleLoadmore}>
            <i className="fas fa-circle-notch"></i> Load more
          </a>
        </div>
      )}
    </>
  );
}

export default Portfolios;
